// extracted by mini-css-extract-plugin
export var contentSection = "_6-8";
export var imageSection = "_6-1";
export var productGrid = "_6-0";
export var productImage = "_6-3";
export var productImageContainer = "_6-2";
export var productInfo = "_6-9";
export var purchaseControls = "_6-a";
export var quantityInput = "_6-c";
export var selectedThumbnail = "_6-6";
export var thumbnailContainer = "_6-4";
export var thumbnailImage = "_6-7";
export var thumbnailItem = "_6-5";
export var variantSelect = "_6-b";